<template>
  <div id="app">
    <router-view/>
    <notifications group="action-alert" />
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'App'
}
</script>

<style>
*{
  box-sizing: border-box;
}
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width: 100%;
    min-height: 100vh;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url('../public/assets/sailboat.jpg');
    height: 100%;
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    justify-content: center;
    font-family: 'Exo', sans-serif;
  }

 .btn-primary{
    color: black !important;
    background-color: #FFC312 !important;
    border-color: #FFC312 !important;
    /* width: 100px; */
  }

 .btn-primary:hover{
    color: black !important;
    background-color: white !important;
    border-color: #FFC312 !important;
  }
  .vue-notification-group{
    top: 80px !important; 
  }
  .flex{
    display: flex;
  }
  .flex-wrap{
    flex-wrap: wrap;
  }
  .flex-column{
    flex-direction: column;
  }

  .cursor-pointer{
    cursor: pointer;
  }
</style>